import _ from "lodash";

export function hydrateMeasurementJSON(data) {
  return {
    jsonData: data.data.jsonData,
    jobOrderId: data.data.jobOrderId,
    measurementId:data.data.measurementId,
  };
}
